<script setup lang="ts">

import {sendWhatsApp} from "@torim-app/utils";
import { trackEvent } from '@app/composables/posthog';

const props = defineProps({
  message: String
})

const handleClick = () => {
  trackEvent('whatsapp_support_clicked');
  sendWhatsApp('972559299380', props.message);
};
</script>

<template>
  <div
    class="py-2 px-4 border border-solid m-2 bg-[#25D366] text-white rounded-3xl border-green-500 flex gap-2 justify-center items-center "
    @click="handleClick">
    <i class="pi pi-whatsapp"/>
    <span class="text-sm">שלחו לנו הודעה</span>
  </div>
</template>

<style scoped lang="scss">

</style>
